export enum BREAD_CRUMB_TYPE {
    vip = 2,
    viewAds = 1,
    default = 0,
}